// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1ZNyW","rootCenter":"LoadMoreObserver_rootCenter__1ACmP","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2izmO"};